import { asyncRouterMap } from "../router";
const state: any = {
    user:null,
    config:null,
    menum:null,
    routers: asyncRouterMap
};

export default state;